/*
  德语
*/
export default {
  Components: {}
}
